import { render } from "./emptyLayout.vue?vue&type=template&id=2cc6bbe8"
import script from "./emptyLayout.vue?vue&type=script&lang=js"
export * from "./emptyLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/layout/emptyLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cc6bbe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cc6bbe8', __exports__)) {
    console.log('reload')
    api.reload('2cc6bbe8', __exports__)
  }
  
  module.hot.accept("./emptyLayout.vue?vue&type=template&id=2cc6bbe8", () => {
    console.log('re-render')
    api.rerender('2cc6bbe8', render)
  })

}


export default __exports__